<div class="wrapper">
  <app-meeting-details-card
    [call]="call"
    [metadata]="call.agendaMetadata"
    [canEdit]="canEdit"
    [title]="'MEETING_SETUP.MEETING_DETAILS.TITLE' | translate"
    (detailsSaved)="onDetailsSaved($event)"
  ></app-meeting-details-card>

  <div class="item meeting-profile-selection">
    <h2 translate="COMMON.CALL_PROFILE"></h2>
    @if (callProfiles$ | async; as result) {
      @if (result.isSuccess) {
        <app-select
          name="call-profile-id"
          [ngModel]="call.callProfileId"
          (ngModelChange)="updateCallProfile($event)"
          [disabled]="!canEdit"
          labelKey="COMMON.CALL_PROFILE"
          nullValueLabelKey="CALLS.ADMIN.ORGANIZATION_DEFAULT"
          [options]="getCallProfileOptions(result.data)"
          [beforeChange]="confirmCallProfileChange"
        ></app-select>
      }
    }
  </div>
  <div class="item document-upload-container">
    <h2 translate="CALLS.CALL_INFO.DOCUMENT_UPLOAD.TITLE"></h2>
    <div class="uploaded-documents-container">
      @if (call.userUploadedResources.length > 0) {
        <h3>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.UPLOADED_DOCUMENTS' | translate }}</h3>
      }
      @for (resource of call.userUploadedResources; track $index) {
        <div class="uploaded-document">
          <mat-icon>attach_file</mat-icon>
          <div class="details">
            <div class="file-info">
              <strong>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.' + resource.resourceType | translate }}:</strong>
              {{ resource.fileName }}
            </div>
            <div class="upload-date">{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.UPLOADED' | translate }}: {{ resource.createdAt | date: 'd MMM y' }}</div>
          </div>
          @if (resource.downloadUrl !== null) {
            <mat-icon class="clickable" (click)="downloadResource(resource)" [matTooltip]="'COMMON.DOWNLOAD' | translate">download</mat-icon>
          }
          @if (isAuthorizedToManageDocuments) {
            <mat-icon class="clickable" color="warn" (click)="removeUpload(resource)" [matTooltip]="'COMMON.REMOVE' | translate">delete</mat-icon>
          }
        </div>
      } @empty {
        <p translate="CALLS.CALL_INFO.DOCUMENT_UPLOAD.NO_DOCUMENTS"></p>
      }
    </div>
    @if (isAuthorizedToManageDocuments && missingDocuments.length > 0) {
      <div class="new-upload-container">
        <h3>{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.UPLOAD_NEW_DOCUMENT' | translate }}</h3>
        @if (call.agendaType === 'MULTIPLE') {
          <div>
            <mat-icon class="warning-icon">warning</mat-icon>
            <span class="warning-text">{{ 'CALLS.CALL_INFO.DOCUMENT_UPLOAD.MULTI_AGENDA_WARNING' | translate }}</span>
          </div>
        }
        <app-call-document-upload [callId]="call.id" [acceptedDocuments]="missingDocuments"></app-call-document-upload>
      </div>
    }
  </div>
  <div class="item minutes-styling">
    @if (call.haveMinuteStylesBeenUpdatedSinceLastProcessing && canEdit) {
      <div class="warning-container">
        <mat-icon class="warning-icon">warning</mat-icon>
        <div class="warning-content">
          <div class="warning-title">{{ 'CALLS.REPROCESS_OUTPUTS.SETTINGS_CHANGED' | translate }}</div>
          <div class="warning-message">
            {{ 'CALLS.REPROCESS_OUTPUTS.WARNING' | translate }}
            <div class="warning-action">
              <button mat-raised-button (click)="reprocessOutputs()">{{ 'CALLS.REPROCESS_OUTPUTS.TITLE' | translate }}</button>
            </div>
          </div>
        </div>
      </div>
    }
    <h2 translate="MINUTES_STYLING.TITLE"></h2>
    <app-minutes-styling
      [namingDisabled]="call.attendeeNames.length === 0"
      [honorificDisabled]="anyAttendeeMissingHonorific"
      [disabled]="!canEdit"
      [data]="call"
      [enabledMinutesLanguages]="(enabledMinutesLanguages$ | async) ?? ['BRITISH', 'AMERICAN']"
      (update)="updateMinutesStyling($event)"
    ></app-minutes-styling>
  </div>
</div>
